/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EvaluationsReportControllerGetEvaluationResultsReport200ResponseDataResultsInner { 
    evaluationId?: string;
    periodId?: string;
    periodName?: string;
    userId?: number;
    userName?: string;
    enrollment?: string;
    departmentName?: string;
    jobPositionName?: string;
    companyName?: string;
    scoresByRelationType?: object;
    generalAverage?: number;
}

